import { IServiceResult, ITableauView } from "../Models/Models";

export interface IVisualization {
  GetViews(): Promise<IServiceResult<ITableauView[]>>;
}
